export { ModalRatePlanVasBlock } from './ValueAddedServices';
export { RentVasBlock } from './ConnectedVasBlocks';
